import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MembershipCustomerWidgetService {

    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getUserOrganization(apiKey){
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });
        return this.http.get(`${this.url}/membershipcustomerwidget/organization`, { headers: headers });
    }

    getAllPlansByOrganization(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/membershipcustomerwidget/plans`, { params: data, headers: headers });
    }

    createMembershipCustomer(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/membershipcustomerwidget/create`, data, { headers: headers });
    }

    sendSessionLink(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/membershipcustomerwidget/session`, data, { headers: headers });
    }
}